import {createSlice} from "@reduxjs/toolkit";
import {FAILED, LOADING, SUCCESS} from "../../common/statuses";
import {
    getInfo,
    getNotifications,
    getPersonalSettings,
    NOTIFICATION,
    readNotification,
    updateSettings
} from "./notificationService";
import {initialState} from "./initState";

const notificationReducer = createSlice({
    name: NOTIFICATION,
    initialState,
    reducers: {
        clearNotificationState: () => {
            return {...initialState}
        }
    },
    extraReducers(builder) {
        builder
            .addCase(getInfo.pending, ({getInfo}) => {
                getInfo.status = LOADING
            })
            .addCase(getInfo.fulfilled, ({getInfo}, action) => {
                getInfo.status = SUCCESS
                getInfo.data = action.payload
            })
            .addCase(getInfo.rejected, ({getInfo}) => {
                getInfo.status = FAILED
            })

            .addCase(getNotifications.pending, ({getNotifications}) => {
                getNotifications.status = LOADING
            })
            .addCase(getNotifications.fulfilled, ({getNotifications}, action) => {
                getNotifications.status = SUCCESS
                getNotifications.data = action.payload
            })
            .addCase(getNotifications.rejected, ({getNotifications}) => {
                getNotifications.status = FAILED
            })

            .addCase(readNotification.fulfilled, ({getNotifications}, action) => {
                let result = new Map(getNotifications.data.map(n => [n.id, n]))
                result.set(action.payload.id, action.payload)
                getNotifications.data = [...result.values()];
            })

            .addCase(getPersonalSettings.pending, ({personalSettings}) => {
                personalSettings.status = LOADING
            })
            .addCase(getPersonalSettings.fulfilled, ({personalSettings}, action) => {
                personalSettings.status = SUCCESS

                const result = {};
                action.payload.forEach(setting => result[setting.notificationType] = setting)

                personalSettings.data = result
            })
            .addCase(getPersonalSettings.rejected, ({personalSettings}) => {
                personalSettings.status = FAILED
            })

            .addCase(updateSettings.pending, ({personalSettings}) => {
                personalSettings.status = LOADING
            })
            .addCase(updateSettings.fulfilled, ({personalSettings}, {payload}) => {
                personalSettings.status = SUCCESS

                const result = {...personalSettings.data}
                result[payload.notificationType] = payload

                personalSettings.data = result
            })
            .addCase(updateSettings.rejected, ({personalSettings}) => {
                personalSettings.status = FAILED
            })
    }
})

export const {clearNotificationState} = notificationReducer.actions;

export default notificationReducer.reducer;
